import { uzCyrl } from "../../../../date-fns/locale/uz-Cyrl.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    uzCyrl
  }
};